import React from 'react';

import PropTypes from 'prop-types';

import { getHighlightedText } from 'helpers/utils';

import { LightDiskBadge } from '../../common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightFlagIcon } from '../../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { LightPanel } from '../../common/fromAuth/LightPanel/LightPanel';
import { DiskBadgeWrapper, PanelRow, PanelRightBlock, LightSelectedDiskBadge } from '../../common/fromAuth/LightPanel/styles';
import { LightText } from '../../common/fromAuth/LightText/LightText';

export const PromoCountryItemPanel = (props) => {
    return (
        <LightPanel onClick={props.onClick} type={props.to ? 'reactLink' : 'link'} to={props.to} isHoverable negativeMargin>
            <PanelRow>
                <PanelRow alignStart>
                    <DiskBadgeWrapper>
                        <LightFlagIcon name={props.flagIconName} size="40px" />
                        {props.isSelectedCountry && (
                            <LightSelectedDiskBadge>
                                <LightDiskBadge variant="selectedPassive" iconName="check" />
                            </LightSelectedDiskBadge>
                        )}
                    </DiskBadgeWrapper>
                    {!!props.query ? (
                        <>{getHighlightedText(props.query, props.countryName, 'lightText', { smallCaps: true })}</>
                    ) : (
                        <LightText>{props.countryName}</LightText>
                    )}
                </PanelRow>
                <PanelRightBlock>
                    {!!props.query ? (
                        <>
                            {getHighlightedText(props.query, props.countryPrefix, 'lightText', {
                                basicColor: 'mediumGray',
                                smallCaps: true,
                            })}
                        </>
                    ) : (
                        <LightText color="mediumGray" smallCaps>
                            {props.countryPrefix}
                        </LightText>
                    )}
                </PanelRightBlock>
            </PanelRow>
        </LightPanel>
    );
};

PromoCountryItemPanel.propTypes = {
    onClick: PropTypes.func,
    to: PropTypes.string,
    flagIconName: PropTypes.string,
    countryName: PropTypes.string,
    countryPrefix: PropTypes.string,
    isSelectedCountry: PropTypes.bool,
};
